import { isObservable, of, take, tap } from 'rxjs';
/**
 * To use extra dependencies or load data required to render the column:
 * don't pass static config but a ModelTableColumnConfigFactory, which can perform asynchronous logic before returning the config object.
 */
export class FeatureFunctionalityModelTableColumn {
  constructor(modelId, displayContext,
  // specify the contexts that the column will be displayed in
  config) {
    this.modelId = modelId;
    this.displayContext = displayContext;
    this.config = config;
    this.__cache = null;
  }
  // internal. used by ModelTableColumnService to solve configuration.
  getConfigCached$(injector) {
    if (this.__cache) return of(this.__cache);
    if (typeof this.config !== 'function') {
      // sync source
      this.__cache = this.config;
      return of(this.__cache);
    } else {
      // maybe async source
      const source = this.config(injector);
      if (isObservable(source)) {
        return source.pipe(take(1), tap(val => {
          this.__cache = val;
        }));
      } else {
        this.__cache = source;
        return of(this.__cache);
      }
    }
  }
}